/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Tokens_CreatedInputs */

const en_tokens_created = /** @type {(inputs: Tokens_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}, never used`)
};

const de_tokens_created = /** @type {(inputs: Tokens_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt ${i?.date}, noch nie benutzt`)
};

/**
* | output |
* | --- |
* | "Created {date}, never used" |
*
* @param {Tokens_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_created = /** @type {((inputs: Tokens_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_created(inputs)
	return en_tokens_created(inputs)
});